<template>
  <div class="filterOptions">
    <div class="tagList">
      <b-badge class="m-1 p-2" v-for="filterCategory in filters.category" :key="'c-'+filterCategory">
        {{categoryName(filterCategory)}}
        <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removeCategory(filterCategory)">&times;</div>
      </b-badge>
      <b-badge class="m-1 p-2" v-for="filterAuthor in filters.author" :key="'a-'+filterAuthor">
        {{authorName(filterAuthor)}}
        <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removeAuthor(filterAuthor)">&times;</div>
      </b-badge>
      <b-badge class="m-1 p-2" v-if="filters.filter">
        <font-awesome-icon icon="search" /> {{filters.filter}}
        <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removeSearch()">&times;</div>
      </b-badge>
      <b-badge class="m-1 p-2" v-for="filterDiscount in filters.discounts" :key="'d-'+filterDiscount">
        {{discountName(filterDiscount)}}
        <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removePromo(filterDiscount)">&times;</div>
      </b-badge>
    </div>
    <div class="filterCategoryTitle">
      <a
        v-b-toggle
        href="#tematica-collapse"
        @click.prevent
        class="d-flex justify-content-between w-100"
      >
        Temática
        <div>
          <b-icon icon="chevron-down" />
          <b-icon icon="chevron-up" />
        </div>
      </a>
    </div>
    <b-collapse id="tematica-collapse">
      <b-list-group flush>
        <template v-for="category in categories">
          <b-list-group-item
            href="#"
            v-if="category.childs.length === 0"
            class="d-flex justify-content-between w-100"
            :key="category.id"
            @click="selCategory(category.id, 1, null)"
          >
            <div>{{ category.name }} <b-icon icon="check" v-if="isselected('category', category.id)" class="text-success"></b-icon></div>
          </b-list-group-item>
          <b-list-group-item href="#" v-else :key="category.id">
            <div class="filterCategoryTitleChild">
              <a
                v-b-toggle
                :href="'#tematica-' + category.id + '-collapse'"
                @click.prevent
                class="d-flex justify-content-between w-100"
              >
                <div @click.prevent="selCategory(category.id, 1, null)">{{ category.name }} <b-icon icon="check" v-if="isselected('category', category.id)" class="text-success"></b-icon></div>
                <div>
                  <b-icon icon="chevron-down" />
                  <b-icon icon="chevron-up" />
                </div>
              </a>
            </div>
            <b-collapse :id="'tematica-' + category.id + '-collapse'">
              <b-list-group flush>
                <b-list-group-item
                  v-for="categoryChild in category.childs"
                  href="#"
                  class="d-flex justify-content-between w-100"
                  :key="categoryChild.id"
                  @click="selCategory(categoryChild.id, 2, category.id)"
                >
                  <div>{{ categoryChild.name }} <b-icon icon="check" v-if="isselected('category', categoryChild.id)" class="text-success"></b-icon></div>
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
          </b-list-group-item>
        </template>
        <!--<b-list-group-item href="#">Categoría 1</b-list-group-item>
        <b-list-group-item href="#">Categoría 2</b-list-group-item>
        <b-list-group-item href="#">Categoría 3</b-list-group-item>-->
      </b-list-group>
    </b-collapse>

    <div class="filterCategoryTitle">
      <a
        v-b-toggle
        href="#autor-collapse"
        @click.prevent
        class="d-flex justify-content-between w-100"
      >
        Autor
        <div>
          <b-icon icon="chevron-down" />
          <b-icon icon="chevron-up" />
        </div>
      </a>
    </div>
    <b-collapse id="autor-collapse">
      <filter-list :filterItems="autorList" @input="selAuthor($event)" />
    </b-collapse>
    <div class="filterCategoryTitle" v-if="discounts.length > 0">
      <a
        v-b-toggle
        href="#promos-collapse"
        @click.prevent
        class="d-flex justify-content-between w-100"
      >
        Promociones
        <div>
          <b-icon icon="chevron-down" />
          <b-icon icon="chevron-up" />
        </div>
      </a>
    </div>
    <b-collapse id="promos-collapse" v-if="discounts.length > 0">
      <b-list-group flush>
          <b-list-group-item
            v-for="discount in discounts"
            href="#"
            class="d-flex justify-content-between w-100"
            :key="discount.id"
            @click="selPromo(discount.id)"
          >
            <div>{{ discount.name }} <b-icon icon="check" v-if="isselected('discounts', discount.id)" class="text-success"></b-icon></div>
          </b-list-group-item>
     </b-list-group>
    </b-collapse>

    <div class="mt-5">
      <label>Precio</label>
    </div>
    <b-form-row>
      <b-col>
        <b-input v-model="prices.min" type="number" placeholder="Min." min="0" />
      </b-col>
      <b-col>
        <b-input v-model="prices.max" type="number" placeholder="Máx." min="1" />
      </b-col>
      <b-col cols="auto" class="text-center">
        <b-button
          class="rounded-circle"
          style="width: 2.5rem;padding-left: 0.6rem;padding-top: 2px;height: 2.5rem;margin-top: -.2rem;"
          @click="setPrice()"
        >
          <b-icon icon="chevron-right" />
        </b-button>
      </b-col>
    </b-form-row>
    <div class="d-none d-md-block mt-5 p-3" style="background: #c8c3c240; border-radius: 1rem;">
      <div style="font-size: 16px; font-weight: 500; margin-bottom: .1rem;">
        Lista de precios
      </div>
      <div style="font-family: 'Nunito Sans', sans-serif; font-size: 14px;">
        Consultá nuestro catálogo descargándolo acá
        <div
          class="border-top border-bottom my-2 py-2"
          style="font-weight: bold;"
        >
          Lista vigente al {{ priceList.vigency }}
          <b-button
            class="rounded-circle float-right"
            style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
            @click="openLink(priceList.file)"
          >
            <b-icon icon="chevron-right" />
          </b-button>
        </div>
      </div>
    </div>
    <div class="d-none d-md-block mt-3 p-3" style="background: #c8c3c240; border-radius: 1rem;">
      <div style="font-size: 16px; font-weight: 500; margin-bottom: .1rem;">
        Distribuidores/Librerías
      </div>
      <div style="font-family: 'Nunito Sans', sans-serif; font-size: 14px;">
        También podés encontrar los libros de La Crujía en:
        <div class="my-2 py-2 text-right" style="font-weight: bold;">
          Ver más detalles
          <b-button
            class="rounded-circle"
            style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
            to="/distribuidores"
          >
            <b-icon icon="chevron-right" />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FilterList from "@/components/FilterList.vue";
import axios from "axios";

export default {
  components: {
    FilterList
  },
  props: ['value', 'priceList'],
  data() {
    return {
      autorList: [],
      categories: {},
      discounts: [],
      filters: {
        author: [],
        category: [],
        discounts: [],
        price:{},
        filter: ''
      },
      prices:{
        min: "",
        max: ""
      }      
    };
  },
  mounted() {
    this.filters = this.value;
    this.getCategories();
    this.getAuthors();
    this.getPromos();
  },
  methods: {
    async getCategories() {
      console.log(this.$store.state.user.siteData);

      this.categories = await axios
        .post(
          this.$store.state.user.siteData.location + "categories/categories",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = {};
          evtResponse.data.records.forEach(element => {
            if (element.parent && element.parent !== null) {
              result[element.parent].childs.push(element);
            } else {
              result[element.id] = element;
              result[element.id].childs = [];
            }
          });
          return result;
        });
    },
    async getAuthors() {
      console.log(this.$store.state.user.siteData);

      this.autorList = await axios
        .post(
          this.$store.state.user.siteData.location + "authors/authors",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            if (element.lastname){
              result.push({ label: element.lastname + ' ' + element.name, id: element.id });
            }else{
              result.push({ label: element.name , id: element.id });
            }
          });
          result.sort(function(a, b){
            var x = a.label.toLowerCase();
            var y = b.label.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
          });
          return result;
        });
    },
    selCategory(category, level, categoryParent) {
      if (!this.filters.category.includes(category)){
        
        const toremove = [];

        if (level === 1){
          const childIDs = [];
          
          this.categories[category].childs.forEach((element) => {
            childIDs.push(element.id);
          });
          
          this.filters.category.forEach((element) => {
            if (this.categories[element] !== undefined || !childIDs.includes(element)){
              toremove.push(element);
            }
            if (childIDs.includes(element)){
              toremove.push(element);
            }            
          });          
        }else{
          this.filters.category.forEach((element) => {
            if (this.categories[element] !== undefined && element !== categoryParent){
              toremove.push(element);
            }
            if (element === categoryParent){
              toremove.push(element);
            }
          });
        }
        if (toremove.length > 0){
          toremove.forEach((element) => {
            this.removeCategory(element);
          });
        }

        this.filters.category.push(category);

        this.$emit("input", this.filters);
      }
    },
    removeCategory(category){
      this.filters.category.splice( this.filters.category.indexOf(category) ,1);
      this.$emit("input", this.filters);
    },
    selAuthor(author) {
      if (!this.filters.author.includes(author)){
        this.filters.author.push(author);
        this.$emit("input", this.filters);
      }
    },
    removeAuthor(author){
      this.filters.author.splice( this.filters.author.indexOf(author) ,1);
      this.$emit("input", this.filters);
    },
    removeSearch(){
      this.filters.filter = "";
      this.$emit("input", this.filters);
    },
    categoryName(category){
        if (this.categories[category]){
          return this.categories[category].name;
        }else{
          let name = '';
          for(const categoryItems in this.categories){
            if (this.categories[categoryItems].childs.length !== 0){              
              this.categories[categoryItems].childs.forEach((element) => {                
                if (parseInt(element.id) === parseInt(category)){
                  name = element.name;
                }
              });
            }
          }
          return name;
        }
    },
    authorName(author){
      let name = '';
      this.autorList.forEach((element) => {
        if (element.id === author){
          name = element.label;
        }
      });
      return name;
    },
    setPrice(){
      this.filters.price = Object.assign({},this.prices);
      this.$emit("input", this.filters);
      console.log(this.prices);
    },
    isselected(filter, id){
      return this.filters[filter].includes(id)
    },
    async getPromos() {
      console.log(this.$store.state.user.siteData);

      await axios
        .post(
          this.$store.state.user.siteData.location + "discounts/dgroups/getForStore",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.discounts = [];
          evtResponse.data.records.forEach(element => {
            this.discounts.push(element);
          });
          this.filters.discounts.forEach((element, findex) => {
            if (isNaN(element)){
              let found = false;
              evtResponse.data.records.forEach(relement => {
                if (relement.name === element){
                  this.filters.discounts[findex] = relement.id;
                  found = true;
                }
              });
              if (!found){
                this.filters.discounts.splice(findex, 1);
              }
            }
          });
          this.$emit("input", this.filters);
          return true;
        });
    },
    discountName(discount){
      let name = '';
      this.discounts.forEach((element) => {
        if (element.id === discount){
          name = element.name;
        }
      });
      return name;
    },
    selPromo(dicount) {
      if (!this.filters.discounts.includes(dicount)){
        this.filters.discounts.push(dicount);
        this.$emit("input", this.filters);
      }
    },
    removePromo(dicount){
      this.filters.discounts.splice( this.filters.discounts.indexOf(dicount) ,1);
      this.$emit("input", this.filters);
    },
    openLink(link){
      window.open(link);
    }
  }
};
</script>
